import { render, staticRenderFns } from "./VueGoodTableSwitchCompactMode.vue?vue&type=template&id=c2a57b76&"
import script from "./VueGoodTableSwitchCompactMode.vue?vue&type=script&lang=js&"
export * from "./VueGoodTableSwitchCompactMode.vue?vue&type=script&lang=js&"
import style0 from "./VueGoodTableSwitchCompactMode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports